import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MuiInputBase(theme: Theme): Components['MuiInputBase'] {
  return {
    styleOverrides: {
      root: {
        padding: theme.spacing(0, 0, 0, 3),
        '&.Mui-disabled': {
          '& svg': {
            color: theme.palette.text.disabled,
          },
        },
      },
      input: {
        lineHeight: 1.4,
        '&::placeholder': {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
  };
}
